import type {
    FC
} from "react";
import {
    View
} from "react-native";
import type IFieldContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useFieldOutsideWarning,
    useFieldContext
} from "../../context";

const FieldContent: FC<IFieldContentProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const context = useFieldContext();

    useFieldOutsideWarning({
        isInside: !!context,
        parent: "Field",
        part: "Content"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        isHorizontal: context?.orientation === "horizontal",
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default FieldContent;
